import {
  DefaultButton,
  Dialog,
  DialogType,
  IColumn,
  IDetailsListStyleProps,
  IDetailsListStyles,
  IStyleFunctionOrObject,
  Icon,
  Panel,
  PanelType,
  PrimaryButton,
  SearchBox,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { TableSelectRow } from "../../../components/Table/TableSelectRow";
import { useAsignacionPersonasEquipo } from "../../../hooks/CheckList/Configuraciones/useAsignacionPersonasEquipo";
import { FooterTable } from "../../../components/Table/FooterTable";
import { IDeletePersonaModeloEquipo } from "../../../Interfaces/IAutorizacionModeloEquipo";
import { IPersonaByEquipo } from "../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { useBoolean } from "@fluentui/react-hooks";
import themeBase from "../../../utils/theme/themeBase";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";

interface IPanelAsignacionEquipo {
  isOpen: boolean;
  onDismiss: () => void;
  modeloEquipo: string;
  modeloEquipoId: string;
}

export const PanelAsignacionEquipo = (props: IPanelAsignacionEquipo) => {
  const [requestDelete, setRequestDelete] =
    useState<IDeletePersonaModeloEquipo>(null!);
  const [deleteAutorizacionModel, { toggle: toggleHideAutorizacionModel }] =
    useBoolean(true);

  const styleTable: IStyleFunctionOrObject<
    IDetailsListStyleProps,
    IDetailsListStyles
  > = {
    root: {
      maxHeightheight: "calc(100vh - 5rem)",
    },
  };
  const {
    loading,
    ocultarMensaje,
    item,
    response,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearchModeloEquipo,
    onClickNext,
    onClickPrevius,
    deletePersonaByModeloEquipo,
  } = useAsignacionPersonasEquipo(props.modeloEquipoId, props.isOpen);

  const column: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 250,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "nroDoi",
      name: "DNI",
      fieldName: "nroDoi",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "area",
      name: "Áea",
      fieldName: "area",
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "opcionesa",
      name: "Opciones",
      fieldName: "opt",
      minWidth: 70,
      maxWidth: 70,
      isResizable: true,
      onRender: (item: IPersonaByEquipo) => (
        <TooltipHost content={`Eliminar`}>
          <Icon
            className="ms-fontSize-16 "
            iconName="RemoveFromTrash"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => {
              setRequestDelete({
                personaId: item.personaId,
                equipoModeloId: props.modeloEquipoId,
              });
              toggleHideAutorizacionModel();
            }}
          />
        </TooltipHost>
      ),
    },
  ];

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="Add"
          subTextHeader={`Asignacion de Equipos`}
          textHeader={`Personas Asignadas al Modelo ${props.modeloEquipo}`}
        />
      </>
    ),
    [props.modeloEquipo]
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          onClick={() => {}}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [props.onDismiss]
  );

  useEffect(() => {
    if (props.isOpen) {
      console.log("este es el modelo", props.modeloEquipoId);
    }
  }, [props.isOpen]);

  return (
    <Panel
      //onRenderFooter={onRenderFooter}
      onRenderHeader={onRenderHeader}
      type={PanelType.largeFixed}
      isFooterAtBottom={true}
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px 0px",
          maxHeight: "calc(100vh - 3rem)",
        }}>
        <Stack horizontal padding={0} style={{ width: "100%" }}>
          <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col  ms-lg11">
                <SearchBox
                  componentRef={searchBoxRefTable}
                  placeholder={"Buscar Por Nombre"}
                  onKeyUp={_onkeyUpSearchModeloEquipo}
                />
              </div>
            </div>
          </div>
        </Stack>
        <div
          style={{
            position: "relative",
            overflow: "auto",
            maxHeight: "calc(100vh - 170px)",
          }}>
          <TableSelectRow
            loading={loading}
            styles={styleTable}
            columns={column}
            items={item}
            leftBar={[]}
          />
        </div>
        <div style={{ margin: "10px", height: "50px" }}>
          <FooterTable
            onClickNext={onClickNext}
            onClickPrevius={onClickPrevius}
            TotalData={paginacion?.total}
            PaginaActual={paginacion?.page}
            TotalPagina={paginacion?.pages}
          />
        </div>
      </div>

      <Dialog
        hidden={deleteAutorizacionModel}
        isBlocking={true}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: "Eliminar Autorizaci[on de Modelo de Equipo",
          subText: "¿Está seguro de Eliminar a esta Persona?",
        }}>
        <MensajeBar ocultar={ocultarMensaje} response={response} />
        <br />
        <br />
        <Stack
          horizontal
          tokens={themeBase.StackTokens10}
          horizontalAlign="end">
          <DefaultButton
            text="Cancelar"
            onClick={() => {
              toggleHideAutorizacionModel();
            }}
            allowDisabledFocus
          />
          {!response ? (
            <PrimaryButton
              text="Eliminar"
              onClick={() => {
                deletePersonaByModeloEquipo(requestDelete);
              }}
              allowDisabledFocus
            />
          ) : (
            <PrimaryButton
              text="Salir"
              onClick={() => {
                toggleHideAutorizacionModel();
              }}
              allowDisabledFocus
            />
          )}
        </Stack>
      </Dialog>
    </Panel>
  );
};
